import { render, staticRenderFns } from "./itinerary-item.vue?vue&type=template&id=de1fc75a"
import script from "./itinerary-item.vue?vue&type=script&lang=js"
export * from "./itinerary-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports